import React, { useContext, useEffect } from "react";
import { MyContext } from "../../MyContextApi";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import axios from "axios";
import NavBar from "./Dashboard/NavBar";
import ReactProSidebar from "./Dashboard/ReactProSidebar";
import coming from "../../images/coming.jpg";
export default function SentimentDashboard() {
  return (
    <>
      <div className="container">
        <NavBar />
        <main>
          <div className="image-container">
            <img
              src={coming}
              alt="Sentiment Analysis"
              className="dashboard-image"
            />
          </div>
        </main>
        <ReactProSidebar />

        <style>
          {`
            main {
              padding: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
            }

            .image-container {
              background-color: white;
              border: 3px solid #e0e0e0;
              border-radius: 15px;
              padding: 20px;
              box-shadow: 
                0 10px 15px -3px rgba(0, 0, 0, 0.1),
                0 4px 6px -2px rgba(0, 0, 0, 0.05),
                0 0 0 1px rgba(0, 0, 0, 0.05);
              transition: transform 0.2s ease, box-shadow 0.2s ease;
              width:800px;
            }

            .image-container:hover {
              transform: translateY(-2px);
              box-shadow: 
                0 20px 25px -5px rgba(0, 0, 0, 0.1),
                0 10px 10px -5px rgba(0, 0, 0, 0.04),
                0 0 0 1px rgba(0, 0, 0, 0.05);
            }

            .dashboard-image {
              display: block;
              max-width: 100%;
              height: auto;
              border-radius: 8px;
            }
          `}
        </style>
      </div>
    </>
  );
}
